import "assets/css/jquery.webui-popover.css";
import SVG from "../core/SVG";
import { friendAvatar } from "utils/assets_exports/images";

import popoverImg from "assets/img/popover2.jpg";

const UserPopover = () => {
    return (
        <div className="webui-popover pop webui-no-padding bottom-right ">
            <div className="webui-arrow" style={{ left: "21px" }}></div>
            <div className="webui-popover-inner">
                <div className="webui-popover-content">
                    <div className="profile-popover-block">
                        {/* <div className="loader-overlay">
                            <div className="loader is-loading"></div>
                        </div> */}

                        <div className="profile-popover-wrapper">
                            <div className="popover-cover">
                                <img className="cover-img" src={popoverImg} />
                                <div className="popover-avatar">
                                    <img
                                        className="avatar"
                                        src={friendAvatar}
                                    />
                                </div>
                            </div>

                            <div className="popover-meta pr-10 pl-10">
                                <span className="user-meta">
                                    <span className="username">Dan Walker</span>
                                </span>
                                {/* <!--span className="job-title">Developer</span--> */}
                                <div className="common-friends">
                                    {/* <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        stroke-width="2"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        className="feather feather-users"
                                    >
                                        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                                        <circle cx="9" cy="7" r="4"></circle>
                                        <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                                        <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                                    </svg> */}
                                    <SVG
                                        svg="community"
                                        size={16}
                                        className="light-grey-svg"
                                    />
                                    <div className="text">
                                        4 mutual friend(s)
                                    </div>
                                </div>
                                <div className="user-location">
                                    {/* <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        stroke-width="2"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        className="feather feather-map-pin"
                                    >
                                        <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                                        <circle cx="12" cy="10" r="3"></circle>
                                    </svg> */}
                                    <SVG
                                        svg="map-pointer"
                                        size={16}
                                        className="light-grey-svg"
                                    />
                                    <div className="text">
                                        From <a href="#">New york</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="popover-actions pb-20">
                            <div className="popover-icon d-flex flex-j-center flex-a-center">
                                <SVG
                                    svg="bookmark"
                                    size={18}
                                    className="light-grey-svg"
                                />
                            </div>
                            <div className="popover-icon d-flex flex-j-center flex-a-center">
                                <SVG
                                    svg="message-circle"
                                    size={18}
                                    className="light-grey-svg"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default UserPopover;
